import { render, staticRenderFns } from "./activity-details-nolive.vue?vue&type=template&id=dcb2c226&scoped=true"
import script from "./activity-details-nolive.vue?vue&type=script&lang=js"
export * from "./activity-details-nolive.vue?vue&type=script&lang=js"
import style0 from "./activity-details-nolive.vue?vue&type=style&index=0&id=dcb2c226&prod&lang=scss&scoped=true"
import style1 from "./activity-details-nolive.vue?vue&type=style&index=1&id=dcb2c226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2c226",
  null
  
)

export default component.exports